var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Breadcrumbs, SyfLoader } from 'syf-component-library/ui/atoms';
import getDisputes from '../../redux/allDisputes/getDisputes';
import triggerAnalyticsEvent, { Analytics } from '../../helpers/analyticsMiddleware';
import Accordion from '../../ui/patterns/Accordion';
import { Stack } from 'syf-component-library/ui/spacing';
import TechnicalError from '../../pages/TechnicalError';
import ErrorBoundary from '../../ui/atoms/ErrorBoundary';
import DisputesFailureError from '../../ui/patterns/Accordion/subcomponents/DisputesFailureError';
import { unsetAccountID } from '../../redux/appConfig/appConfig.slice';
import { ModalType } from '../../redux/ui/typings';
import { AccordionWrapper, BreadCrumbContainer, DisputeModal, LoaderWrapper } from './subcomponents';
var AllDisputes = function (_a) {
    var navigation = _a.navigation;
    var dispatch = useDispatch();
    var _b = useSelector(function (state) { return state; }), _c = _b.ui, isLoading = _c.isLoading, modalType = _c.modalType, accountId = _b.appConfig.accountId, _d = _b.globalAuth, isAuthenticated = _d.isAuthenticated, isAuthFailure = _d.isAuthFailure;
    useEffect(function () {
        /**
         * Note: We need to block this call from happening if the accountId is not valid or else getDisputes call will fail
         *
         * Typically we would be able to get accountId from getDisputes using the getState() function, but this action is being
         * called before the accountID is set with a string value and causing the API call to fail.
         *
         * This action is being passed an accountId parameter until a better solution can be found to consistently fetch the value
         * from the store's current state.
         *
         * BUG: the Redux Provider is mounted at the same time as this component thus the store is not yet updated, causing the undefined
         */
        if (isAuthenticated && accountId) {
            dispatch(getDisputes(accountId));
        }
    }, [accountId, dispatch, isAuthenticated]);
    useEffect(function () {
        return function () {
            dispatch(unsetAccountID());
        };
    }, [dispatch]);
    useEffect(function () {
        triggerAnalyticsEvent({
            PageKind: Analytics.Activity,
            PageFunction: Analytics.DisputeTransaction,
            pageName: Analytics.View
        });
    }, []);
    if (isAuthFailure) {
        return _jsx(TechnicalError, {});
    }
    /*
     * NOTE: Avoid collision with other modals that may use `isLoading`.
     * TODO: Add a `isLoading` prop to allDisputes slice so we don't need to
     * share it and make extra checks.
     */
    if (isLoading && modalType === ModalType.DisputeDetail) {
        return (_jsx(LoaderWrapper, { children: _jsx(SyfLoader, { size: 4.375 }) }));
    }
    return (_jsxs(AccordionWrapper, { children: [(navigation === null || navigation === void 0 ? void 0 : navigation.navigationHandler) && (_jsx(BreadCrumbContainer, { children: _jsx(Breadcrumbs, { items: navigation === null || navigation === void 0 ? void 0 : navigation.navigationItems, navigationHandler: navigation === null || navigation === void 0 ? void 0 : navigation.navigationHandler }) })), _jsx(Stack, { size: "medium" }), _jsx(ErrorBoundary, __assign({ fallback: _jsx(DisputesFailureError, {}) }, { children: _jsx(Accordion, {}) })), _jsx(DisputeModal, { modalType: modalType })] }));
};
export default AllDisputes;
//# sourceMappingURL=index.js.map